import { useQuery } from "@tanstack/react-query";
import useAuthenticatedApiRequest from "../../AuthenticatedApiRequest";
import TchrURL from "../../TchrURL";

export interface User {
  creditsUsed: number;
  creditsRemaining: number;
  creditsMax: number;
  trialActive: boolean;
  trialUsed: boolean;
  paused: boolean;
  active: boolean;
  isOrganisation: boolean;
  stytchId: string;
  stripeReferenceId: string;
  stripeCustomerId: string;
  trialStart: string;
  trialEnd: string;
  checkoutSessionId: string;
  settings: {
    firstName: string | null;
    middleName: string | null;
    lastName: string | null;
    school: string | null;
    pilot: boolean;
    pilotEmail: string | null;
    templates: [];
    language: string | null;
  };
  subscribed: boolean;
  id: string;
  creationDate: string;
  isDeleted: boolean;
  deletionDate: string | null;
  stripeCustomer: {
    status: string;
    subscriptionId: string | null;
    coupon: string | null;
    price: number | null;
    currency: string | null;
    id: string | null;
    creationDate: string | null;
    isDeleted: boolean | null;
    deletionDate: string | null;
    discountPercent: number | null;
    interval: "month" | "year" | null;
  } | null;
}

const useUser = ({ enabled }: { enabled: boolean }) => {
  const { get } = useAuthenticatedApiRequest();
  return useQuery<User, Error, User>({
    queryKey: ["user"],
    queryFn: async () => {
      const url = new TchrURL("/user");
      const response = await get(url);
      if (!response.ok) {
        throw new Error("Failed to fetch user data");
      }
      return response.json();
    },
    staleTime: 1000 * 60 * 5,
    enabled,
  });
};

export default useUser;
